import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    background: theme.palette.grey[200],
    padding: theme.spacing(2),
    margin: '16px 0',
    borderRadius: 8
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      margin: '-2px 0'
    }
  },
  input: {
    height: 38
  },
  inputDisable: { opacity: 0.5 },
  header: {
    fontWeight: 600,
    marginBottom: 20,
    color: theme.palette.text.primary
  },
  label: { color: theme.palette.text.primary, fontSize: 14 },
  text: { fontWeight: 600, color: theme.palette.text.primary },

  textField: { width: '100%', marginTop: 7 },
  timeText: {
    color: theme.palette.grey[800],
    fontWeight: 600,
    marginLeft: 8
  },
  textRoot: {
    // height: '4px',

    '& .MuiInputBase-input': { height: '2px', margin: 0.5 },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: `1.5px solid ${theme.palette.grey[600]}` // default color
      },
      '&:hover fieldset': {
        border: `1px solid ${theme.palette.grey[600]}` // prevent hover color
      },
      '&.Mui-focused fieldset': {
        border: `1px solid ${theme.palette.grey[600]}` // prevent focus color
      }
    }
  },
  radioIcon: {
    '& svg': {
      fontSize: 18
    }
  },
  inputNumber: {
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  }
}))
